import React, { useMemo } from "react";
import CampaignsLoader from "Loader/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "store/store.interface";
import {
  fetchBulkBundleJobs,
  searchForBulkJobs,
  updateBulkBundlePageNumber,
} from "store/actions/bulkBundleUtility.actions";
import { useApiInfo } from "hooks";
import { BULK_BUNDLE_FETCH_JOBS } from "store/store.types";
import { isEmpty } from "utils/app.utils";
import { Box, Link } from "common";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { useStyles } from "components/Dashboard/Dashboard.style";

const LoadMoreBulkJobs = () => {
  const classes = useStyles({});
  const { bulkBundleJobs, total, limit, page } = useSelector(
    (state: IState) => ({
      ...state.bulkBundlePromotion,
      ...state.config,
      ...state.auth,
    })
  );

  const { searchTerm } = useSelector((state: IState) => state.promotion);

  const { isLoading: isFetchingBulkJobs } = useApiInfo(BULK_BUNDLE_FETCH_JOBS);
  const dispatch = useDispatch();

  const onClick = () => {
    if (shouldShowLoadMore) {
      const newPageNumber = page + 1;
      dispatch(updateBulkBundlePageNumber(newPageNumber));
      if (searchTerm) {
        dispatch(searchForBulkJobs({ searchTerm, page: newPageNumber }));
      } else {
        dispatch(fetchBulkBundleJobs({ page: newPageNumber }));
      }
    }
  };

  const isLoading = useMemo(() => {
    return isFetchingBulkJobs && !isEmpty(bulkBundleJobs);
  }, [isFetchingBulkJobs, bulkBundleJobs]);

  const shouldShowLoadMore = useMemo(() => {
    return (page + 1) * limit <= total + limit;
  }, [page, limit, total]);

  if (shouldShowLoadMore) {
    if (isLoading) {
      return <CampaignsLoader />;
    }
    return (
      <Box
        mt="30px"
        alignItems="center"
        display="flex"
        data-testid="load-more-bulk-jobs-link"
        justifyContent="center"
      >
        <Link
          data-testid="load-more-bulk-jobs-button"
          onClick={onClick}
          variant="default"
          color="primary"
          className={classes.loadMore}
        >
          <Box
            fontSize="16px"
            flexDirection="column"
            display="flex"
            alignItems="center"
          >
            <span>Show more</span>
            <ExpandMore color="primary" />
          </Box>
        </Link>
      </Box>
    );
  }
  return null;
};

export default LoadMoreBulkJobs;
